import { useEffect, useState } from "react"
import { ReactSetterType } from "utils/types";
import _ from 'lodash';

type PartOf<T> = {[K in keyof T]? : T[K]}

const useObject = <T extends {},>(initialState : T):[T, (a: PartOf<T>)=>void, ReactSetterType<T>, (a: (prev : T)=>T)=>void]=>{
    const [object, setObject] = useState(initialState)

    function setPartialObject(partialObj: PartOf<T>){
        setObject({...object, ...partialObj});
    }

    /*
    * @desc NEVER USE STATE MUTATING (E.G ARRAY.PUSH) FUNCTION
    * @desc NEVER USE USE PREV VALUE IN RIGHT SIDE OF ASSIGNMENT (E.G prev => prev.b = [...prev, 1])
    * @desc THIS METHOD ONLY INTENDED FOR ASSIGNMENT (E.G prev => prev.a = 1)
    * @param {function}
    * @returns {void}
    */
    function intentObject(fn: (prev: T)=>T){
        setObject((prev)=>_.cloneDeep(fn(prev)));
    }

    return [object, setPartialObject, setObject, intentObject];
}

export default useObject;